import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { REQUEST_ERROR, ROUTING_TRAMITE_PENSION_INVALIDEZ } from '@constants/url.constant';
import { InvalidezHomeComponent } from './pages/invalidez-home/invalidez-home.component';
import { InvalidezLayoutComponent } from './components/invalidez-layout/invalidez-layout.component';
import { RequestErrorComponent } from './pages/request-error/request-error.component';
import { PiSolicitudLayoutComponent } from './components/pi-solicitud-layout/pi-solicitud-layout.component';
import { InvalidezSeguridadComponent } from './pages/invalidez-seguridad/invalidez-seguridad.component';
import { loadRemoteModule } from '@angular-architects/module-federation';
import { environment } from 'src/environments/environment';
import { InvalidezPersonalDataComponent } from './pages/invalidez-personal-data/invalidez-personal-data.component';

const ROUTES: Routes = [
  {
    path: '',
    component: InvalidezLayoutComponent,
    children: [
      {
        path: '',
        component: InvalidezHomeComponent,
        pathMatch: 'full',
      },
    ],
  },
  {
    path: ROUTING_TRAMITE_PENSION_INVALIDEZ.REQUEST,
    component: PiSolicitudLayoutComponent,
    children: [
      {
        path: "",
        redirectTo: ROUTING_TRAMITE_PENSION_INVALIDEZ.SEGURIDAD,
        pathMatch: "full",
      },
      {
        path: ROUTING_TRAMITE_PENSION_INVALIDEZ.SEGURIDAD,
        component: InvalidezSeguridadComponent,
        data: { gtm: { event_name: 'tramite_pension', paso_numero: '1', paso_nombre: 'modulo_validacion' } },
        loadChildren: () =>
          loadRemoteModule({
            type: "module",
            remoteEntry: environment.SECURITY_REMOTE_ENTRY_URL,
            exposedModule: "./VALIDACIONES",
          }).then((m) => m.ValidacionesModule),
      },
      {
        path: ROUTING_TRAMITE_PENSION_INVALIDEZ.DATOS_PERSONALES,
        component: InvalidezPersonalDataComponent,
        data: { gtm: { event_name: 'tramite_pension', paso_numero: '2', paso_nombre: 'tu_informacion' } }
      },
    ],
  },
  {
    path: REQUEST_ERROR,
    component: RequestErrorComponent,
    pathMatch: "full",
  },
];

@NgModule({
  imports: [RouterModule.forChild(ROUTES)],
  exports: [RouterModule],
})
export class TramitePensionInvalidezRoutesModule { }
